import React, { useState, useEffect } from "react";
import { StarPin } from "./map/StarPin";

export const Instructions = (props) => {
  const [instructionModalOpen, setInstructionModalOpen] = useState(false);
  const handleModalClose = () => {
    setInstructionModalOpen(false);
  };

  useEffect(() => {
    let modal_status = localStorage.getItem("modal_status");
    if (!modal_status) {
      setInstructionModalOpen(true);
      localStorage.setItem("modal_status", 1);
    }
  }, []);

  if (!instructionModalOpen) return null;

  return (
    <div
      className={`absolute w-3/4 left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 glass flex flex-col justify-center items-center p-4 rounded-md ${
        instructionModalOpen ? "" : "hidden"
      }`}
    >
      <p className="text-center text-sm">
        Click on a pin to view upcoming events at that location.
      </p>
      <div className="relative ripple-repeat my-8">
        <StarPin
          className={`h-8 w-8 razz transform transition relative cursor-pointer h-10 w-10 opacity-100 scale-110 ping`}
        />
      </div>
      <button
        onClick={handleModalClose}
        className="py-2 px-4 bg-blue-500 text-white font-semibold rounded-md shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75 z-top"
      >
        lets go!
      </button>
    </div>
  );
};
